import getConfig from "next/config";

export const env = process.env.NODE_ENV || "development";
export const isDev = env === "development";
export const appName = process.env.APP_NAME ?? "Procedure Hub";
export const isServerSide = typeof window === "undefined";
export const isCI = process.env.CI === "true";

interface PublicRuntimeConfig {
  maintainXUrl?: string;
  landingPageUrl?: string;
  branchFallbackUrl?: string;
  serverGraphUrl?: string;
  gtmId?: string;
  branchKey?: string;
  frontendUrl?: string;
  basePath?: string;
  datadogAppId?: string;
  datadogClientToken?: string;
  datadogSampleRate: number;
  appEnv?: string;
  version?: string;
  logLevel?: string;
}

interface ServerRuntimeConfig {
  serverGraphUrl?: string;
}

export function getPublicRuntimeConfig(): PublicRuntimeConfig {
  return getConfig().publicRuntimeConfig;
}

export function getServerRuntimeConfig(): ServerRuntimeConfig {
  return getConfig().serverRuntimeConfig;
}

export function getClientSideGraphqlPath() {
  return `${getPublicRuntimeConfig().basePath}/api/graphql`;
}
